import { render, staticRenderFns } from "./PrivateChatsFilters.vue?vue&type=template&id=fd08f6b0&"
import script from "./PrivateChatsFilters.vue?vue&type=script&lang=js&"
export * from "./PrivateChatsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports